import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { PractitionerDayOff } from 'src/app/core/model/v2/practitioner/practitioner-day-off';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { MyErrorStateMatcher } from 'src/app/shared/components/MyErrorStateMatcher/MyErrorStateMatcher.component';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { PhysicianOptionService } from '../shared/physician-option/physician-option.service';

@Component({
  selector: 'app-day-off',
  templateUrl: './day-off.component.html',
  styleUrls: ['./day-off.component.scss']
})
export class DayOffComponent implements OnChanges {
@Input() practitioner:any;

  practitionerDayOff: PractitionerDayOff = new PractitionerDayOff();
  inputStartDate: Date = new Date();

  matcher = new MyErrorStateMatcher();
  conceptFormControl = new FormControl('', [Validators.required]);
  startDateFormControl = new FormControl('', [Validators.required]);
  endDateFormControl = new FormControl('', [Validators.required]);
  allDayFormControl = new FormControl('', []);
  startTimeFormControl = new FormControl('', []);
  endTimeFormControl = new FormControl('', []);

  dataForm: FormGroup = new FormGroup({
    concept: this.conceptFormControl,
    startDate: this.startDateFormControl,
    endDate: this.endDateFormControl,
    allDay: this.allDayFormControl,
    startTime: this.startTimeFormControl,
    endTime: this.endTimeFormControl
  });

  constructor(private practiceService: PracticeService,
    private physicianOptionService: PhysicianOptionService,
    private loaderService: WindowLoaderService,
    private snackBar: MatSnackBar) { }

  ngOnChanges() {
    this.practitionerDayOff.isFullDay = true;
    this.practitionerDayOff.practitionerId = this.practitioner.id;
    this.practitionerDayOff.healthSystemId = this.practitioner.healthSystems[0].id;

  }

  checkAllDay(): void {
    this.practitionerDayOff.isFullDay = !this.practitionerDayOff.isFullDay;
  }

  saveDayOff(): void {
    if (!this.physicianOptionService.hasValues()) {
      return;
    }
    //const practitioner = this.physicianOptionService.getPhysician();
    //const healthSystem = this.physicianOptionService.getHealthSystem();

    //this.practitionerDayOff.practitionerId = this.practitioner.id;
    //this.practitionerDayOff.healthSystemId = healthSystem.id;

    if (this.practitionerDayOff.isFullDay) {
      this.practitionerDayOff.startTime = '00:00:00';
      this.practitionerDayOff.endTime = '23:59:59';
    }

    this.loaderService.show();
    this.practiceService.addPractitionerDayOff(this.practitionerDayOff).subscribe(
      (res) => {
        this.snackBar.open(`Day off added to ${this.practitioner.fullName}`, 'Ok');
        this.loaderService.hide();
      },
      (error) => { console.error(error); this.loaderService.hide(); },
      () => { this.loaderService.hide(); }
    )
  }

}
